import React, { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";
import { motion } from "framer-motion"; // Framer Motion'ı dahil ediyoruz
import "../../dist.css/UserMealAddPage.css"; // Stil dosyasını unutmayın
import { toast } from "react-toastify"; // react-toastify'yi dahil ediyoruz
import { ToastContainer } from "react-toastify"; // ToastContainer'ı dahil et
// Supabase client'ını oluşturuyoruz
const supabase = createClient(
  "https://qlgwpthiwclfbgzzjmjw.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsZ3dwdGhpd2NsZmJnenpqbWp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ2MDUzOTIsImV4cCI6MjA0MDE4MTM5Mn0.N9-IULDnpuUWR_PNXvXyzdTTIMRsxRAxVGrAagaJn4k"
);

const UserMealAddPage = () => {
  const [mealData, setMealData] = useState({
    image_url: "",
    title: "",
    content: "",
    created_at: new Date().toISOString().split("T")[0], // Bugünün tarihi
    materials: "",
    category: "",
    area: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [user, setUser] = useState(null); // Kullanıcı oturumu
  const [imageFile, setImageFile] = useState(null); // Seçilen dosya için state

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImageFile(e.target.files[0]); // Dosyayı state'e ekler
    }
  };
  const uploadImage = async (file) => {
    const fileName = `${Date.now()}-${file.name}`; // Benzersiz dosya adı
    const { error } = await supabase.storage
      .from("meal-images")
      .upload(fileName, file);

    if (error) {
      console.error("Resim yükleme hatası:", error.message);
      alert("Resim yüklenirken bir hata oluştu: " + error.message);
      return null;
    }

    const { data: publicData } = supabase.storage
      .from("meal-images")
      .getPublicUrl(fileName);

    return publicData.publicUrl;
  };

  // Kullanıcı oturum bilgisini kontrol et
  useEffect(() => {
    const checkAuth = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      setUser(user);
    };
    checkAuth();
  }, []);

  // Kullanıcıdan gelen input verisini state'e kaydet
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMealData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Formu gönderme işlemi
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Resmi yükle
    const imageUrl = await uploadImage(imageFile);

    if (!imageUrl) {
      setError("Resim yükleme başarısız oldu.");
      setLoading(false);
      return;
    }

    // Yemek verisini kaydet
    const { error } = await supabase.from("meals").insert([
      {
        ...mealData,
        image_url: imageUrl, // Resim URL'sini kaydet
      },
    ]);

    if (error) {
      setError("Yemek eklenirken bir hata oluştu: " + error.message);
    } else {
      // Başarı mesajı
      toast.success("Yemek başarıyla eklendi!"); // Success bildirimi

      // Formu sıfırlama
      setMealData({
        image_url: "",
        title: "",
        content: "",
        created_at: new Date().toISOString().split("T")[0],
        materials: "",
        category: "",
        area: "",
      });
      setImageFile(null);
    }

    setLoading(false);
  };

  return (
    <motion.div
      className="UserMealAddPage"
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 1, delay: 0.5, type: "spring" }}
    >
      <h1>Yemek Ekle</h1>

      <ToastContainer
        position="top-right" // Bildirim sağ üstte görünsün
        autoClose={3000} // 3 saniye sonra kaybolur
        hideProgressBar={true} // İlerleme çubuğunu gizle
        newestOnTop={true} // En yeni bildirim üstte
        closeButton={false} // Kapatma butonunu gizle
        rtl={false} // Arapça okuma yönü
      />
      {user ? (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="image_url">Yemek Görseli URL</label>
            <input
              type="file"
              id="image_upload"
              name="image_upload"
              accept="image/*"
              onChange={handleFileChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="title">Yemek Başlığı</label>
            <input
              type="text"
              id="title"
              name="title"
              value={mealData.title}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="content">Yemek Tarifi</label>
            <textarea
              id="content"
              name="content"
              value={mealData.content}
              onChange={handleInputChange}
              required
              placeholder="Lütfen her bir cümleden sonra alt satıra geçiniz"
            />
          </div>

          <div className="form-group">
            <label htmlFor="created_at">Oluşturulma Tarihi</label>
            <input
              type="date"
              id="created_at"
              name="created_at"
              value={mealData.created_at}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="materials">Malzemeler</label>
            <textarea
              id="materials"
              name="materials"
              value={mealData.materials}
              onChange={handleInputChange}
              required
              placeholder="Lütfen eklediğiniz her bir malzemeden sonra alt satıra geçiniz"
            />
          </div>

          <div className="form-group">
            <label htmlFor="category">Kategori</label>
            <input
              type="text"
              id="category"
              name="category"
              value={mealData.category}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="area">Bölge</label>
            <input
              type="text"
              id="area"
              name="area"
              value={mealData.area}
              onChange={handleInputChange}
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Yükleniyor..." : "Yemek Ekle"}
          </button>
        </form>
      ) : (
        <p className="error">
          Yemek ekleyebilmek için giriş yapmanız gerekiyor.
        </p>
      )}

      {error && <p className="error">{error}</p>}
    </motion.div>
  );
};

export default UserMealAddPage;
